// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingResultTableFilterBar-moduleDocFlowMappingResultTableFilterBar__Lbehv";
var _2 = "DocFlowMappingResultTableFilterBar-moduletoggle__i8VKf FilterBar-moduletableToggle__64X3V";
export { _1 as "DocFlowMappingResultTableFilterBar", _2 as "toggle" }
